import React from 'react'
import Footer from '../../../components/Footer/Footer'
import PageHeader from './PageHeader'
import CoursesSection from './CoursesSection'
import NavBarHome from '../../../components/NavBar/NavBarHome'

function CoursesList() {
   return (
      <div className="pt-[92px] flex flex-col min-h-screen">
         <NavBarHome />

         <section className="mb-16">
            <PageHeader
               title="Offre GoNextmaker"
               description="GoNextmaker adopte une approche active et orientée création, déployée sous format bootcamp combinant des sessions hybrides (présentiel + en ligne)."
               bgColor="bg-white"
            />
         </section>

         <section className="mb-16 mx-[88px]">
            <CoursesSection />
         </section>

         <section>
            <Footer
               logo={"/Logo NextMaker.png"}
               bgColor="bg-dark-1"
               textColor="text-gray-100"
               borderColor="border-gray-400/20"
            />
         </section>
      </div>
   )
}

export default CoursesList